import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { TableTd } from '../../Zemplin/General/Table';
import { ProductPriceCartTable } from './ProductPriceCartTable';
import { getProductDefaultInfo } from '../../../utilities/selectors';
import { StockInfo } from './StockInfo';

export interface Props {
  apiUrl: string;
  product: any;
  addToRequest: any;
  addToCart: any;
}

function ProductTabRowTable({
  apiUrl,
  product,
  addToCart,
  addToRequest,
}: Props) {
  const {
    availid,
    availability,
    picture,
    url,
    name,
    price,
    unit,
    oldPrice,
  } = getProductDefaultInfo(product, apiUrl);

  return (
    <>
      <ImageNameTableTd>
        <ImageWrapper to={url}>
          <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
        </ImageWrapper>
        <NameWrapper>
          <StyledLink to={url}>
            <Name>{name}</Name>
          </StyledLink>
          <ProductCode>{product.plu}</ProductCode>
          <StockInfo availability={availability} avail_id={availid} />
          <Description>{name}</Description>
        </NameWrapper>
      </ImageNameTableTd>
      <ProductPriceCartTable
        price={price}
        oldPrice={oldPrice}
        isSale={product.is_sale}
        salePercentage={product.main_good.sale_percentage}
        addToRequest={addToRequest}
        addToCart={addToCart}
        avail_id={availid}
        unit={unit}
      />
    </>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)};
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(24)};
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
`;

const NameWrapper = styled(FlexCol)`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(130)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(100)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }
`;

const ProductCode = styled(TextP)`
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  font-size: ${rem(14)};
  font-weight: 400;
`;

const Description = styled(ProductCode)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(440)};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

export { ProductTabRowTable };
